import { useCallback, useEffect, useMemo, useState } from 'react';
// Hooks.
// -----------------------------------------------------------------------------
export const useDropdown = ({ options, refOptions }) => {
    // Hooks.
    // ---------------------------------------------------------------------------
    const [isOpen, setIsOpen] = useState(false);
    const [clickedOption, setClickedOption] = useState();
    // Variables.
    // ---------------------------------------------------------------------------
    const hasIcons = useMemo(() => options.every((option) => Boolean(option.icon)), [options]);
    // Handlers.
    // ---------------------------------------------------------------------------
    const handleOnClickCTA = useCallback(() => {
        setIsOpen((prev) => !prev);
    }, []);
    const handleOnClickOption = useCallback(async (option) => {
        if (!clickedOption) {
            if (option.isAsync) {
                setClickedOption(option);
            }
            await option.callback();
            setIsOpen(false);
            setClickedOption(undefined);
        }
    }, [clickedOption]);
    const handleOnClickOptionButton = useCallback(async (option) => {
        await handleOnClickOption(option);
    }, [handleOnClickOption]);
    const handleOnClickOptionLink = useCallback(async (option, event) => {
        event.preventDefault();
        await handleOnClickOption(option);
    }, [handleOnClickOption]);
    // Effects.
    // ---------------------------------------------------------------------------
    useEffect(() => {
        // On Esc.
        const handleOnEsc = (event) => {
            if (event.key === 'Escape') {
                event.preventDefault();
                setIsOpen(false);
            }
        };
        // Outside click.
        const handleOutsideClick = (event) => {
            if (refOptions.current &&
                !refOptions.current.contains(event.target)) {
                event.preventDefault();
                setIsOpen(false);
            }
        };
        if (isOpen) {
            document.addEventListener('click', handleOutsideClick);
            document.addEventListener('keydown', handleOnEsc);
        }
        else {
            document.removeEventListener('click', handleOutsideClick);
            document.removeEventListener('keydown', handleOnEsc);
        }
        return () => {
            document.removeEventListener('keydown', handleOnEsc);
            document.removeEventListener('click', handleOutsideClick);
        };
    }, [isOpen, refOptions]);
    // Return.
    // ---------------------------------------------------------------------------
    return {
        clickedOption,
        hasIcons,
        isOpen,
        isWaiting: Boolean(clickedOption),
        onClickCTA: handleOnClickCTA,
        onClickOptionButton: handleOnClickOptionButton,
        onClickOptionLink: handleOnClickOptionLink
    };
};
//# sourceMappingURL=Dropdown.hooks.js.map